import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { CommunityAuthService } from '../../services/community-auth.service';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../environments/environment';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    RouterModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class SessionExpiredComponent implements OnInit {
  // @ViewChild("hiddenIframe", { static: true }) iframe!: HTMLIFrameElement;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<SessionExpiredComponent>,
    private _router: Router,
    private _authService: CommunityAuthService
  ) { }

  ngOnInit(): void {
  }

  staySignedOut(): void {
    this._authService.logout();
    this.dialogRef.close();
  }

  login(): void {
    const returnTo = this._router.url.startsWith("/unauthorized") ? "/" : this._router.url;
    // //window.open(window.location.host + "/relogin");
    // console.log(this.iframe);
    // this.iframe.src = "www.google.com";
    this._authService.login(returnTo);
    this.dialogRef.close();
  }
}
